import axios from "./index";

class home {
    //获取火车列表
    static getTrainsList(params) {
        return axios.get("/business-trains/trains/search", { params: params });
    }

    //生成订单
    static createOrder(params) {
        return axios.post('/business-trains/trains/createOrder',params)
    }

    //生成改签订单
    static changeOrder(params) {
        return axios.post('/business-trains/change',params)
    }


    //获取火车票详情
    static getTrainsDetail(params) {
        return axios.get("/business-trains/trains/searchDetail", { params: params });
    }
    //获取订单列表
    static getOrderList(params) {
        return axios.get("/business-trains/trains/getPageList", { params: params });
    }
    //获取订单详情
    static getOrderDetail(orderCode) {
        return axios.get(`/business-trains/trains/detail/${orderCode}`,{headers:{
            NO_LOADING : true
        }});
    }

    //获取退票详情
    static getRefundDetail(params) {
        return axios.get(`/business-trains/refund/info/${params.orderCode}/${params.passengerId}`);
    }


    //退票
    static refund(params) {
        return axios.post(`/business-trains/refund/${params.orderCode}/${params.passengerId}`);
    }


    //取消订单接口
    static cancelOrder(params) {
        return axios.post(`/business-trains/trains/cancel`,params);
    }

    //确认订单接口
    static confirmOrder(params) {
        return axios.post(`/business-trains/trains/pay`,params);
    }

    //获取改签单详情
    static changeOrderDetail(orderCode) {
        return axios.get(`/business-trains/trains/detail/change/${orderCode}`,{headers:{
            NO_LOADING : true
        }});
    }

    //跳转到确认改签
    static getChangeOrder(orderCode) {
        return axios.get(`/business-trains/change/getChangeOrder/${orderCode}`);
    }


    //生成支付订单去支付
    static goPay(params) {
        return axios.post(`/business-trains/trains/go-pay`,params);
    }


    //抢票单预览
    static robPre(params) {
        return axios.post(`/business-trains/rush_ticket_order/pre`,params);
    }

    //新建抢票单
    static robOrder(params) {
        return axios.post(`/business-trains/rush_ticket_order`,params);
    }


    //抢票单详情
    static robOrderDetail(orderCode) {
        return axios.get(`/business-trains/rush_ticket_order/info/${orderCode}`);
    }


    //抢票单列表
    static robOrderList(params) {
        return axios.get(`/business-trains/rush_ticket_order/page_list`,{params:params});
    }

    //取消抢票单
    static robCancel(orderCode) {
        return axios.post(`/business-trains/rush_ticket_order/cancel/${orderCode}`);
    }


    
    
    //获取保险
    static getInsuranceList(params) {
        return axios.get("/business-trains/insurance/getInsuranceList", { params: params });
    }


    //抢票单去支付
    static robToPay(params) {
        return axios.post(`/business-trains/rush_ticket_order/pay`,params);
    }

    //火车经停站
    static trainStopStation(params) {
        return axios.get(`/business-trains/trains/trainStopStation`,{params:params});
    }

}

export default home;
